/* Unique Skin – ordering helpers (TEST theme only).
   Display-only: quantity on cards, slide-out cart, Professional/Retail toggle,
   "Load more" and search suggestions. Product visibility still comes from the
   theme's existing permission snippets; nothing here changes tags, collections or SKUs. */
(function () {
  'use strict';

  var PREVIEW = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ? 'preview_theme_id=' + Shopify.theme.id : '';
  function withPreview(u) { return PREVIEW ? u + (u.indexOf('?') > -1 ? '&' : '?') + PREVIEW : u; }
  function money(c) { return '£' + (Number(c || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  var SIZE_RX = /[-–]\s*(Professional|Salon Size|Retail)\b/i;
  function sizeOf(card) {
    var n = card.querySelector('.product-name, p');
    var m = (n ? n.textContent : card.textContent).match(SIZE_RX);
    if (!m) return '';
    return /retail/i.test(m[1]) ? 'retail' : 'professional';
  }

  /* ---------------- Slide-out cart ---------------- */
  var drawer, body, subEl, msgEl, lastKey = null;
  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 's26-cart';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="s26-cart__scrim" data-s26-close></div>' +
      '<aside class="s26-cart__panel" role="dialog" aria-modal="true" aria-label="Your cart">' +
        '<header class="s26-cart__head"><h3>Your cart</h3><button type="button" class="s26-cart__x" data-s26-close aria-label="Close cart">&times;</button></header>' +
        '<p class="s26-cart__msg" hidden></p>' +
        '<div class="s26-cart__body"></div>' +
        '<footer class="s26-cart__foot">' +
          '<div class="s26-cart__sub"><span>Subtotal</span><strong></strong></div>' +
          '<p class="s26-cart__note">Delivery is calculated at checkout.</p>' +
          '<a class="s26-cart__go" href="/checkout">Checkout</a>' +
          '<div class="s26-cart__links"><a href="/cart">Review order</a><button type="button" data-s26-close>Continue shopping</button></div>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(drawer);
    body = $('.s26-cart__body', drawer);
    subEl = $('.s26-cart__sub strong', drawer);
    msgEl = $('.s26-cart__msg', drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-s26-close]')) { e.preventDefault(); closeDrawer(); return; }
      var step = e.target.closest('[data-line-step]');
      if (step) {
        var row = step.closest('[data-key]');
        var input = $('input', row);
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-line-step'), 10));
        changeLine(row.getAttribute('data-key'), q);
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.closest('[data-key]').getAttribute('data-key'), 0); }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('.s26-line input');
      if (input) changeLine(input.closest('[data-key]').getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }
  function openDrawer() {
    buildDrawer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('s26-lock');
    setTimeout(function () { var x = $('.s26-cart__x', drawer); if (x && drawer.classList.contains('is-open')) x.focus({ preventScroll: true }); }, 320);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('s26-lock');
    if (drawer.contains(document.activeElement)) document.activeElement.blur();
    if (document.body.scrollLeft) document.body.scrollLeft = 0;
  }
  function showMsg(text) {
    buildDrawer();
    if (!text) { msgEl.hidden = true; return; }
    msgEl.textContent = text; msgEl.hidden = false;
  }
  function setCount(n) { $$('.cart-count').forEach(function (el) { el.textContent = n; }); }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    buildDrawer();
    setCount(cart.item_count);
    subEl.textContent = money(cart.total_price);
    $('.s26-cart__foot', drawer).hidden = !cart.item_count;
    if (!cart.item_count) {
      body.innerHTML = '<div class="s26-cart__empty"><p>Your cart is empty.</p><button type="button" data-s26-close>Keep shopping</button></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="s26-line__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="s26-line' + (it.key === lastKey ? ' is-new' : '') + '" data-key="' + esc(it.key) + '">' +
        '<a class="s26-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="s26-line__info"><a class="s26-line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="s26-line__row"><span class="s26-stepper"><button type="button" data-line-step="-1" aria-label="Decrease">&minus;</button><input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" value="' + it.quantity + '" aria-label="Quantity"><button type="button" data-line-step="1" aria-label="Increase">+</button></span>' +
          '<strong class="s26-line__p">' + money(it.final_line_price) + '</strong></div>' +
          '<button type="button" class="s26-line__rm" data-line-remove>Remove</button>' +
        '</div></div>';
    }).join('');
  }
  function refresh() { return getCart().then(renderCart); }
  function changeLine(key, qty) {
    drawer.classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (cart) { lastKey = null; showMsg(''); renderCart(cart); })
      .catch(function (err) { showMsg((err && (err.description || err.message)) || 'Sorry, that quantity could not be updated.'); refresh(); })
      .then(function () { drawer.classList.remove('is-busy'); });
  }
  function addItems(payload, btn) {
    if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
    var opts = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (payload instanceof FormData) opts.body = payload;
    else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(payload); }
    return fetch('/cart/add.js', opts)
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        var first = d.items ? d.items[0] : d;
        lastKey = first && first.key;
        showMsg('');
        return refresh().then(openDrawer);
      })
      .catch(function (err) {
        showMsg((err && (err.description || err.message)) || 'Sorry, that could not be added.');
        return refresh().then(openDrawer);
      })
      .then(function () { if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; } });
  }

  // Take over every "Add to cart" button on product lists (capture phase, so the old handlers don't also fire)
  document.addEventListener('click', function (e) {
    var qtyZone = e.target.closest('.s26-qty');
    if (qtyZone) {
      e.preventDefault(); e.stopPropagation();
      var step = e.target.closest('[data-step]');
      if (step) {
        var inp = $('input', qtyZone);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(step.getAttribute('data-step'), 10));
      }
      return;
    }
    var btn = e.target.closest('.btn-add-cart');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var card = btn.closest('a.product-item, .grid-item, .product-card') || btn.parentElement;
      var q = card ? $('.s26-qty input', card) : null;
      var qty = Math.max(1, parseInt(q && q.value, 10) || 1);
      addItems({ items: [{ id: Number(btn.getAttribute('data-id')), quantity: qty }] }, btn).then(function () { if (q) q.value = 1; });
      return;
    }
    var cartLink = null;
    if (cartLink && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      refresh().then(openDrawer);
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest && e.target.closest('.s26-qty input');
    if (!inp) return;
    e.preventDefault();
    var card = inp.closest('a.product-item');
    var b = card && $('.btn-add-cart', card);
    if (b) b.click();
  }, true);
  // Digits only in our quantity boxes
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.closest && t.closest('.s26-qty, .s26-stepper')) t.value = t.value.replace(/[^0-9]/g, '');
  }, true);
  // Product page form
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action="/cart/add"]')) return;
    e.preventDefault();
    addItems(new FormData(f), $('[type="submit"]', f));
  }, true);

  /* ---------------- Quantity on cards ---------------- */
  function enhanceCards(root) {
    $$('a.product-item .btn-add-cart', root).forEach(function (btn) {
      if (btn.getAttribute('data-s26')) return;
      btn.setAttribute('data-s26', '1');
      var wrap = document.createElement('span');
      wrap.className = 's26-buy';
      wrap.innerHTML = '<span class="s26-qty"><button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button><input type="text" value="1" inputmode="numeric" pattern="[0-9]*" maxlength="4" aria-label="Quantity"><button type="button" data-step="1" aria-label="Increase quantity">+</button></span>';
      btn.parentNode.insertBefore(wrap, btn);
      wrap.appendChild(btn);
    });
  }

  /* ---------------- Collection page: Load more + size toggle ---------------- */
  var grid, nextUrl = null, loading = null, moreBtn, sizeSel = '';
  function cardsIn(doc) { return $$('#collection-products .product-list a.product-item', doc); }
  function appendFrom(doc) {
    var seen = {};
    cardsIn(document).forEach(function (a) { seen[(a.getAttribute('href') || '').split('?')[0]] = 1; });
    cardsIn(doc).forEach(function (a) {
      var k = (a.getAttribute('href') || '').split('?')[0];
      if (seen[k]) return;
      seen[k] = 1;
      grid.appendChild(document.importNode(a, true));
    });
    var n = $('#collection-products .paginate .next a', doc);
    nextUrl = n ? n.getAttribute('href') : null;
  }
  function loadNext() {
    if (!nextUrl) return Promise.resolve();
    if (loading) return loading;
    if (moreBtn) { moreBtn.disabled = true; moreBtn.textContent = 'Loading…'; }
    loading = fetch(withPreview(nextUrl), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { appendFrom(parse(t)); })
      .catch(function () { nextUrl = null; })
      .then(function () { loading = null; afterChange(); });
    return loading;
  }
  function loadAll() {
    if (!nextUrl) return Promise.resolve();
    return loadNext().then(loadAll);
  }
  function updateMore() {
    if (!moreBtn) return;
    moreBtn.hidden = !nextUrl;
    moreBtn.disabled = false;
    moreBtn.textContent = 'Load more products';
  }
  function applySize() {
    if (!grid) return;
    var shown = 0;
    cardsIn(document).forEach(function (a) {
      var hide = !!sizeSel && sizeOf(a) !== sizeSel;
      a.classList.toggle('s26-hide', hide);
      if (!hide) shown++;
    });
    var empty = $('.s26-empty');
    if (!shown && sizeSel) {
      if (!empty) { empty = document.createElement('p'); empty.className = 's26-empty'; grid.parentNode.insertBefore(empty, grid.nextSibling); }
      empty.textContent = 'No ' + (sizeSel === 'retail' ? 'retail' : 'professional') + ' sizes in this list.';
      empty.hidden = false;
    } else if (empty) empty.hidden = true;
  }
  function afterChange() {
    enhanceCards(grid);
    applySize();
    updateMore();
    if (window.usbRun) window.usbRun();
  }
  function setupCollection() {
    grid = $('#collection-products .product-list');
    if (!grid) return;
    var params = new URLSearchParams(location.search);
    var merged = !!params.get('cats');
    var pag = $('#collection-products .paginate');
    if (pag && !merged) {
      var n = $('.next a', pag);
      nextUrl = n ? n.getAttribute('href') : null;
      pag.style.display = 'none';
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 's26-more';
      moreBtn.addEventListener('click', function () { loadNext(); });
      pag.parentNode.insertBefore(moreBtn, pag);
      updateMore();
    }
    // Size toggle (only where the list actually has professional/retail items)
    var bar = $('#collection-products .c26-bar');
    sizeSel = params.get('size') || '';
    if (bar && customerHasCards()) {
      var seg = document.createElement('div');
      seg.className = 's26-seg';
      seg.setAttribute('role', 'group');
      seg.setAttribute('aria-label', 'Show sizes');
      seg.innerHTML = '<button type="button" data-size="">All sizes</button><button type="button" data-size="professional">Professional</button><button type="button" data-size="retail">Retail</button>';
      bar.appendChild(seg);
      var paint = function () { $$('button', seg).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-size') === sizeSel ? 'true' : 'false'); }); };
      seg.addEventListener('click', function (e) {
        var b = e.target.closest('[data-size]');
        if (!b) return;
        sizeSel = b.getAttribute('data-size');
        paint();
        var u = new URL(location.href);
        if (sizeSel) u.searchParams.set('size', sizeSel); else u.searchParams.delete('size');
        history.replaceState(null, '', u.pathname + u.search);
        if (sizeSel && nextUrl) { grid.classList.add('s26-busy'); loadAll().then(function () { grid.classList.remove('s26-busy'); applySize(); }); }
        applySize();
      });
      paint();
      if (sizeSel && nextUrl) loadAll();
    }
    // Re-apply whenever the grid content changes (e.g. multi-category merge)
    new MutationObserver(function () { enhanceCards(grid); applySize(); }).observe(grid, { childList: true });
    afterChange();
  }
  function customerHasCards() { return !!$('#collection-products .product-list a.product-item'); }

  /* ---------------- Search suggestions ---------------- */
  function setupSearch() {
    var input = $('.form-search input[name="input-search"]');
    if (!input) return;
    var box = input.closest('.form-search');
    var list = document.createElement('div');
    list.className = 's26-sugg';
    list.hidden = true;
    list.setAttribute('role', 'listbox');
    document.body.appendChild(list);
    function place() {
      var r = input.getBoundingClientRect();
      var w = Math.min(420, window.innerWidth - 24);
      list.style.top = Math.round(r.bottom + 8) + 'px';
      list.style.left = Math.round(Math.max(12, Math.min(r.right - w, window.innerWidth - w - 12))) + 'px';
      list.style.width = w + 'px';
    }
    window.addEventListener('resize', function () { if (!list.hidden) place(); });
    window.addEventListener('scroll', function () { if (!list.hidden) place(); }, true);
    input.setAttribute('autocomplete', 'off');
    var timer, seq = 0, active = -1;
    function close() { list.hidden = true; active = -1; }
    function rows() { return $$('.s26-sugg__item', list); }
    function highlight(i) {
      var r = rows();
      r.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      active = i;
    }
    function run(q) {
      var my = ++seq;
      place();
      list.hidden = false;
      list.innerHTML = '<div class="s26-sugg__msg">Searching…</div>';
      fetch(withPreview('/search?type=product&q=' + encodeURIComponent(q + '*')), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          if (my !== seq) return;
          var d = parse(t);
          var items = $$('.search-result', d).map(function (el) {
            var a = $('a[href*="/products/"]', el);
            if (!a) return null;
            var img = $('img', el);
            var title = $('p', a);
            var price = $('.product-item--price', el);
            var priceTxt = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
            if (/login/i.test(priceTxt)) priceTxt = '';
            return { url: a.getAttribute('href').split('?')[0], img: img ? img.getAttribute('src') : '', title: title ? title.textContent.trim() : '', price: priceTxt };
          }).filter(Boolean).slice(0, 8);
          var all = '<a class="s26-sugg__all" href="/search?q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '”</a>';
          if (!items.length) { list.innerHTML = '<div class="s26-sugg__msg">No matching products.</div>' + all; return; }
          list.innerHTML = items.map(function (it) {
            return '<a class="s26-sugg__item" role="option" href="' + esc(it.url) + '">' +
              (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '<span class="s26-sugg__ph"></span>') +
              '<span class="s26-sugg__t">' + esc(it.title) + '</span>' +
              (it.price ? '<span class="s26-sugg__p">' + esc(it.price) + '</span>' : '') + '</a>';
          }).join('') + all;
          active = -1;
        })
        .catch(function () { if (my === seq) list.innerHTML = '<div class="s26-sugg__msg">Search is unavailable right now.</div>'; });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { seq++; close(); return; }
      timer = setTimeout(function () { run(q); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      var r = rows();
      if (e.key === 'ArrowDown' && r.length) { e.preventDefault(); highlight(Math.min(r.length - 1, active + 1)); }
      else if (e.key === 'ArrowUp' && r.length) { e.preventDefault(); highlight(Math.max(0, active - 1)); }
      else if (e.key === 'Enter' && active > -1 && r[active]) { e.preventDefault(); e.stopPropagation(); location.href = r[active].getAttribute('href'); }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && !list.contains(e.target)) close(); });
    input.addEventListener('focus', function () { if (list.innerHTML && input.value.trim().length >= 2) { place(); list.hidden = false; } });
  }

  function labelCart() { if (!document.getElementById('s26-cartlabel-css')) { var st = document.createElement('style'); st.id = 's26-cartlabel-css'; st.textContent = '#icon-cart a[href="/cart"]{display:inline-flex;align-items:center;color:#fff;text-decoration:none}.s26-cartlabel{margin-left:16px;margin-right:14px;font-family:"Poppins",sans-serif;font-size:13px;font-weight:500;color:#fff;white-space:nowrap}#icon-cart a[href="/cart"]:hover .s26-cartlabel{text-decoration:underline}@media (max-width:599px){.s26-cartlabel{display:none}}'; document.head.appendChild(st); } $$('#icon-cart a[href="/cart"]').forEach(function (a) { if (a.querySelector('.s26-cartlabel')) return; var s = document.createElement('span'); s.className = 's26-cartlabel'; s.textContent = 'Review order'; a.appendChild(s); a.setAttribute('title', 'Review order'); }); } function kickVideos() { var vids = Array.prototype.slice.call(document.querySelectorAll('video[autoplay]')); if (!vids.length) return; var go = function (v) { v.muted = true; v.defaultMuted = true; v.playsInline = true; if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }; if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) go(en.target); }); }, { threshold: 0.1 }); vids.forEach(function (v) { v.removeAttribute('loading'); io.observe(v); }); } else vids.forEach(go); } function init() {
    setupCollection();
    enhanceCards(document);
    setupSearch(); kickVideos(); labelCart();
    getCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
